import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=d9526ac6"
import script from "./QuestionsView.vue?vue&type=script&lang=js"
export * from "./QuestionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports